// eslint-disable-next-line import/no-cycle
import httpClient from '../utils/http-client';
import extractObjectSubset from '../utils/object';
import Auth from './auth';

const baseAPI = process.env.REACT_APP_BASE_URL;
const ndisNotificationBaseAPI = process.env.REACT_APP_NDIS_NOTIFICATION_BASE_URL;
const auth0API = `https://${process.env.REACT_APP_AUTH0_DOMAIN}`;
const auth0ManagementAPI = `https://${process.env.REACT_APP_AUTH0_MANAGEMENT_DOMAIN}`;

const request =
  (baseUrl, method, headers, options) =>
  async (URL, data, { headers: userHeaders, ...userOptions }) => {
    const currentOptions = { ...options, ...userOptions };
    const httpClientOptions = extractObjectSubset(['timeout', 'abortController'], currentOptions);

    /**
     * For get fresh header every time
     */
    const getHeaders = () => {
      const currentHeaders = { ...headers, ...userHeaders };

      const useLoginToken = currentHeaders['use-login-token'];
      delete currentHeaders['use-login-token'];

      if (useLoginToken) {
        currentHeaders.Authorization = `Bearer ${Auth().getLoginToken()}`;
      } else {
        currentHeaders.Authorization = `Bearer ${Auth().getAccessToken()}`;
      }

      return currentHeaders;
    };

    const currentURL = `${baseUrl}/${URL}`;
    const response = await httpClient(currentURL, method, data, getHeaders(), httpClientOptions);

    if (response.status === 401 || response.status === 403) {
      console.error('token expired, logging out!');
      Auth().logout();

      return response;
    }

    if (Auth().shouldRenewToken()) {
      try {
        await Auth().renewToken();
      } catch (error) {
        console.error('Failed to renew token:', error);
      }
    }

    const responseBody = await response.json();

    // Extract trace ID from headers if available
    const traceId = response.headers.get('X-Trace-Id') || response.headers.get('x-trace-id');

    return {
      ok: response.ok,
      status: response.status,
      body: responseBody,
      traceId,
    };
  };

const generateRestful = (api, methods, headers) =>
  methods.reduce(
    (accumulator, currentValue) => ({
      ...accumulator,
      [currentValue.toLowerCase()]: request(api, currentValue, headers),
    }),
    {},
  );

export default {
  base: generateRestful(baseAPI, ['GET', 'POST', 'PUT', 'DELETE', 'PATCH']),
  ndisNotificationBase: generateRestful(ndisNotificationBaseAPI, [
    'GET',
    'POST',
    'PUT',
    'DELETE',
    'PATCH',
  ]),
  auth0: generateRestful(auth0API, ['GET', 'POST', 'PUT', 'DELETE', 'PATCH']),
  auth0Management: generateRestful(auth0ManagementAPI, ['GET', 'POST', 'PUT', 'DELETE', 'PATCH']),
};
